//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create interaction -------------
export const createOneGameGallery = (returnedPayload) => ({ type: ActionTypes.one_game_gallery.create_one_game_gallery, payload: returnedPayload });



export const deleteOneGameGallery = (returnedPayload) => ({ type: ActionTypes.one_game_gallery.delete_one_game_gallery, payload: returnedPayload });

export const listOneGameGallery = (returnedPayload) => ({ type: ActionTypes.one_game_gallery.list_one_game_gallery, payload: returnedPayload });

